export default "/wp-content/themes/oportun/dist/assets/brand/hero-1a1ee581bb6fac8d.svg"